/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { ItemUpdate } from '@app/data-model/item-update';
import * as _ from 'underscore';
import { State } from '@app/data-model/state';

export class StateUpdate extends ItemUpdate {
  newState: any;

  isAssigned: boolean;
  isAssignedToOther: boolean;
  isAssignedToSelf: boolean;
  isAssignedByOther: boolean;
  isAssignedBySelf: boolean;
  isActivated: boolean;
  isActivatedByOther: boolean;
  isActivatedBySelf: boolean;

  constructor(id, newState, currentUser) {
    super(id);
    this.newState = _.extend(new State(newState, currentUser), newState);
  }
}
